export const BASIC_MAX_CABLECOM_CENT = 2;
export const BASIC_MAX_LOGICA_CENT = 2;
export const BASIC_MAX_LOGICAFM_CENT = 1;
export const BASIC_MAX_PLANIMETRIE = 0;
export const BASIC_MAX_AMBIENTI = 0;
export const MAX_NUMBER_OF_ZONES = 250;



